module.exports = __webpack_public_path__ + "img/CreateLocation7.265ea320.jpg";